import { AuthMethodsPage } from "pages/auth/auth-methods";
import { CodePage } from "pages/auth/code";
import { BindCompaniesPage } from "pages/auth/companies";
import { IdentityVerificationPage } from "pages/auth/identity-verification";
import { LoginPage } from "pages/auth/login";
import { RegistrationPage } from "pages/auth/registration";
import { SignPersonalDataPage } from "pages/auth/sign-personal-data";
import { ConfirmShiftPage } from "pages/confirm-shift";
import { ContractsPage } from "pages/contracts";
import { HelpPage } from "pages/help";
import { MainPage } from "pages/main";
import { NotFoundPage } from "pages/not-found";
import { ProfilePage } from "pages/profile";
import { RequestPage } from "pages/request";
import { RequestsPage } from "pages/requests";
import { SingActPage } from "pages/sing-act";
import { SingContractsPage } from "pages/sing-contracts";
import { TaskPage } from "pages/task";
import { TasksPage } from "pages/tasks";
import { TransactionsStatusPage } from "pages/transactions-status";
import { Outlet, useRoutes } from "react-router-dom";
import { useMonitorRoutes } from "shared/lib/hooks";
import ROUTES from "shared/routes";
import { RequireAuth } from "./require-auth";

export const AppRoutes = () => {
  useMonitorRoutes();

  const elements = useRoutes([
    {
      path: ROUTES.LOGIN,
      element: <LoginPage />,
    },
    {
      path: ROUTES.AUTH_METHODS,
      element: <AuthMethodsPage />,
    },
    {
      path: ROUTES.CODE,
      element: <CodePage />,
    },
    {
      path: ROUTES.REGISTRATION,
      element: <RegistrationPage />,
    },
    {
      path: ROUTES.IDENTITY_VERIFICATION,
      element: <IdentityVerificationPage />,
    },
    {
      path: ROUTES.COMPANIES_BIND,
      element: <BindCompaniesPage />,
    },
    {
      path: ROUTES.SIGN_PERSONAL_DATA,
      element: <SignPersonalDataPage />,
    },
    {
      path: ROUTES.MAIN,
      element: (
        <RequireAuth>
          <Outlet />
        </RequireAuth>
      ),
      children: [
        {
          index: true,
          element: <MainPage />,
        },
        {
          path: ROUTES.IDENTITY_VERIFICATION_MAIN,
          element: <IdentityVerificationPage isMain />,
        },
        {
          path: ROUTES.CONTRACTS,
          element: <ContractsPage />,
        },
        {
          path: ROUTES.SING_CONTRACTS_ID,
          element: <SingContractsPage />,
        },
        {
          path: ROUTES.SING_ACT_ID,
          element: <SingActPage />,
        },
        {
          path: ROUTES.TASKS,
          element: <TasksPage />,
        },
        {
          path: ROUTES.TASKS_ID,
          element: <TaskPage />,
        },
        {
          path: ROUTES.REQUESTS,
          element: <RequestsPage />,
        },
        {
          path: ROUTES.REQUEST_ID,
          element: <RequestPage />,
        },
        {
          path: ROUTES.RA,
          element: <ConfirmShiftPage />,
        },
        {
          path: ROUTES.TRANSACTIONS_ID,
          element: <TransactionsStatusPage />,
        },
        {
          path: ROUTES.PROFILE,
          element: <ProfilePage />,
        },
        {
          path: ROUTES.HELP,
          element: <HelpPage />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);

  return elements;
};
